export default __webpack_public_path__ + "static/media/ejja.e2a0ce30.png";